import { useMemo } from 'react';
import { generateUUID } from '../components/utils';
import { useConfig } from '../config';
import { Res, useApi } from '../state/api';
import { MetaContainer } from '../state/meta';
import { Loop54ProductsRequestBody } from '../types';

export const useLoop54ProductsByIds = (ids: number[]) => {
	const { randomizeSearchProfileId, searchProfileId } = MetaContainer.useContainer();
	const { loop54Api } = useConfig();
	const productIds = useMemo(() => ids.join(','), [ids]);
	const shouldFetch = ids.length > 0;

	const loop54PostHeaders = useMemo(
		() => ({
			'Api-Version': 'V3',
			'User-id': randomizeSearchProfileId ? generateUUID() : searchProfileId,
		}),
		[randomizeSearchProfileId, searchProfileId]
	);

	const loop54ProductsPayload = useMemo<Loop54ProductsRequestBody>(
		() => ({
			resultsOptions: {
				skip: 0,
				take: ids.length,
				filter: {
					or: ids.map((productId) => ({ type: 'id', value: productId.toString() })),
				},
			},
		}),
		[ids]
	);

	return useApi(
		shouldFetch ? Res.productsLoop54 : null,
		{
			productIds,
		},
		loop54Api,
		loop54ProductsPayload,
		loop54PostHeaders,
		'POST'
	);
};
